import Client from '@/repositories/Clients/AxiosClient'
import Config from '@/repositories/Clients/AxiosDefaultConfig'

const resource = `${Config.basePath}/v1/admin/store`

export default {
  index(payload) {
    return Client.get(resource, {
      params: payload,
    })
  },
  create(payload) {
    return Client.post(resource, payload)
  },
  show(id, payload = {}) {
    return Client.get(`${resource}/${id}`, payload)
  },
  update(id, payload) {
    return Client.put(`${resource}/${id}`, payload)
  },
  delete(id, payload) {
    return Client.delete(`${resource}/${id}`, payload)
  },
  getPaymentReceipt(payload) {
    return Client.get(`${resource}/payment_receipt`, {
      params: payload,
    })
  },
  updatePaymentReceipt(payload) {
    return Client.put(`${resource}/payment_receipt`, payload);
  }
}
